import { require200Status } from "../../utils/response.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
import "../../../constants/index.js";
import { API_HEADERS } from "../../../constants/api-client.js";
function publicGamesEndpoints(builder) {
  return {
    getPublicGameList: builder.query({
      providesTags: ["games"],
      query: ({ query, accountId }) => ({
        url: `/game/list${parseQs(query)}`,
        method: "GET",
        headers: {
          [API_HEADERS.ACCOUNT_ID]: accountId
        }
      }),
      transformResponse: transformWithSpec()
    }),
    getPublicGameProviderList: builder.query({
      providesTags: ["game-providers"],
      query: ({ query, accountId }) => ({
        url: `/game/providers${parseQs(query)}`,
        method: "GET",
        headers: {
          [API_HEADERS.ACCOUNT_ID]: accountId
        }
      }),
      transformResponse: transformWithSpec()
    }),
    getPublicGameProviderStats: builder.query({
      providesTags: ["game-providers"],
      query: ({ accountId }) => ({
        url: `/game/stats`,
        method: "GET",
        validateStatus: require200Status,
        headers: {
          [API_HEADERS.ACCOUNT_ID]: accountId
        }
      }),
      transformResponse: transformWithSpec()
    }),
    getPublicGameCategoryList: builder.query({
      providesTags: ["game-categories"],
      query: ({ query, accountId }) => ({
        url: `/category/list${parseQs(query)}`,
        method: "GET",
        headers: {
          [API_HEADERS.ACCOUNT_ID]: accountId
        }
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  publicGamesEndpoints as default
};
